// Adresses des en-têtes de mail (À, Cc) pour les montrer en puces : une couleur par
// adresse, toujours la même, pour voir d'un coup d'œil à qui un mail a été adressé.

export type Destinataire = { nom: string | null; adresse: string | null }

/** Coupe un en-tête aux virgules, sauf entre guillemets ou chevrons. */
function morceaux(entete: string): string[] {
  const parts: string[] = []
  let courant = ''
  let guillemets = false
  let chevrons = false
  for (const c of entete) {
    if (c === '"') guillemets = !guillemets
    else if (c === '<' && !guillemets) chevrons = true
    else if (c === '>' && !guillemets) chevrons = false
    if (c === ',' && !guillemets && !chevrons) {
      parts.push(courant)
      courant = ''
    } else courant += c
  }
  parts.push(courant)
  return parts.map((p) => p.trim()).filter(Boolean)
}

/** Les destinataires d'un en-tête « Nom <adresse>, adresse, … », adresses en minuscules. */
export function adressesDe(entete: string): Destinataire[] {
  return morceaux(entete).map((p) => {
    const m = /<([^<>\s]+@[^<>\s]+)>/.exec(p) ?? /([^\s<>"']+@[^\s<>"']+)/.exec(p)
    if (!m) return { nom: p, adresse: null }
    const adresse = m[1]!.toLowerCase()
    const nom = p
      .replace(m[0], '')
      .trim()
      .replace(/^["']|["']$/g, '')
      .trim()
    return { nom: nom && nom.toLowerCase() !== adresse ? nom : null, adresse }
  })
}

/** Teinte (0 à 359) tirée de l'adresse : la même adresse a toujours la même couleur. */
export function teinteDe(adresse: string): number {
  // FNV-1a 32 bits.
  let h = 0x811c9dc5
  for (const c of adresse.toLowerCase()) {
    h ^= c.codePointAt(0)!
    h = Math.imul(h, 0x01000193)
  }
  return (h >>> 0) % 360
}
